import { createSystem, defaultConfig } from "@chakra-ui/react";

const system = createSystem(defaultConfig, {
    globalCss: {
        body: {
            bg: "white",
            color: "gray.800",
        },
    },
});

export default system;
